import { Component, OnInit, ViewChild } from '@angular/core';
import { SessionService } from "../../../shared/services/session.service";
import { AlertPopupService } from "../../../shared/services/alert-popup.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { CustomerDoLogin, CustomerDoRegister, ResendOtp } from "../../../states/auth/auth.actions";

@Component({
	selector: 'app-verify',
	templateUrl: './verify.component.html',
	styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {
	@ViewChild("ngOtpInput", { static: false })

	public otpConfig = {
		allowNumbersOnly: true, length: 6, isPasswordInput: false,
		disableAutoFocus: true, placeholder: "",
		inputStyles: { width: "70px", height: "50px" },
	};

	constructor(
		private sessionService: SessionService,
		private alertPopupService: AlertPopupService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private store: Store,
	) {
	}
	private timeOut: any
	public resendOtpTimer: number = 60;
	public isTimerActive: boolean = true;

	ngOnInit(): void {
		this.subscribeToSession();
		this.initialConfiguration();
		this.startOtpTimer();
	}

	subscribeToSession() {
		if (this.sessionService.state?.profile) {
			this.router.navigate(['']);
			this.alertPopupService.showWarningAlert('You already have an active session!!!');
		}
	}

	initialConfiguration(): void {
	}

	doValidateOTP(event: string) {
		if (event.length === 6) {
			this.activatedRoute.queryParams.subscribe(data => {
				this.store.dispatch(new CustomerDoLogin({
					...data,
					token: event
				}));
			});
		}
	}

	doLogin(event: string) {
		clearTimeout(this.timeOut)
		this.timeOut = setTimeout(() => {
			this.doValidateOTP(event)
		}, 600)
	}

	public doResendOtp() {
		this.activatedRoute.queryParams.subscribe(data => {
			if (!data.mobile) {
				return;
			}

			// this.store.dispatch(new CustomerDoRegister({
			// 	...data,
			// 	isFirstTime: false,
			// }));
			this.store.dispatch(new ResendOtp({
				...data
			}))
			this.startOtpTimer();
		});
	}

	private startOtpTimer() {
		this.resendOtpTimer = 60;
		this.isTimerActive = true;

		const interval = setInterval(() => {
			if (this.resendOtpTimer > 0) {
				this.resendOtpTimer--;
			} else {
				clearInterval(interval);
				this.isTimerActive = false;
			}
		}, 1000);
	}
}
